import { render, staticRenderFns } from "./documentPreviewDialog.vue?vue&type=template&id=1f5ca379&"
import script from "./documentPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./documentPreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./documentPreviewDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports